<template>
  <div class="d">
  	<h5 class="marginl10">设置非公司隶属的协调人
  		<span class="contactAddStyle" @click="addContacterDialogVisible=true">添加新协调人</span>
  	</h5>
  	<el-table empty-text="暂无数据" :data="cooperaterDataList" border>
  		<el-table-column prop="name" label="协调人">
  		</el-table-column>
  		<el-table-column prop="passport" label="手机号">
      </el-table-column>
  		<el-table-column
  			label="操作"
  			>
  			<template slot-scope="scope">
  				<el-button @click="handleClick(scope.$index)" type="text" size="small">删除</el-button>
  			</template>
  		</el-table-column>
    		</el-table>
		<!-- 添加新注册的协调人 -->
    <el-dialog title="添加新协调人" center :visible.sync="addContacterDialogVisible" width="500px">
    	<div>
        <div id="">
          姓&nbsp;&nbsp;&nbsp;&nbsp;名：<el-input v-model="victimName" placeholder="请输入姓名" style='width: 300px;'></el-input>
        </div>
        <div style="margin-top: 10px;">
          手机号：<el-input v-model="nationalMobile" placeholder="请输入姓名" style='width: 300px;'></el-input>
        </div>
      </div>
    	<div slot="footer" class="dialog-footer">
    		<el-button @click="addContacterDialogVisible = false">取 消</el-button>
    		<el-button type="primary" @click="newDJXid()">确 定</el-button>
    	</div>
    </el-dialog>
  </div>
</template>

<script>
  import { listNormalUser,diffNormalUser,creatBasic } from '@/views/axios/api.js'
  export default{
    data(){
      return {
        addContacterDialogVisible:false,
        token:JSON.parse(window.localStorage.getItem("data")).data,
        cooperaterDataList:[],
        victimName:'',
        nationalMobile:''
      }
    },
    mounted() {
    },
    methods:{
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
			//删除案件中的国内联络人
			handleClick(index){
        this.cooperaterDataList.splice(index,1)
			},
      getData(id){
        var data={
          token:this.token,
          caseId:id
        }
        listNormalUser(data)
        .then(res => {
          console.log(res);
          this.cooperaterDataList=res.data.obj
        })
        .catch(err => {
          console.log(err);
        })
      },
      setData(id){
        var data={
          token:this.token,
          caseId:id,
          fids:''
        }
        diffNormalUser(data)
        .then(res => {
          console.log(res);
        })
        .catch(err => {
          console.log(err);
        })
      },
      //创建大救星账户
      newDJXid() {
        if(this.victimName==''){
      		return this.$message.error("出险人姓名不能为空");
      	}else if(this.nationalMobile==''){
      		return this.$message.error("手机号不能为空")
      	}
        var data={
          token:this.token,
          name:this.victimName,
          nationalMobile:this.nationalMobile
        }
        creatBasic(data)
        .then(res => {
          console.log(res);
          if(res.data.code == 0){
            this.$message.success('创建成功')
            this.addContacterDialogVisible=false;
            // this.cooperaterDataList.forEach(item => {
            //   item.id
            // })
            this.cooperaterDataList.push(res.data.obj)
            this.victimName='';
            this.nationalMobile='';
            var ruserId=''
            this.cooperaterDataList.forEach((item,index) => {
              if(index < this.cooperaterDataList.length - 1){
                ruserId+='ruserId='+ item.id+'&'
              }else{
                ruserId+='ruserId='+ item.id
              }
            })
            this.$parent.getRuserId(ruserId)
          }else{
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err);
        })
      },
    }
  }
</script>

<style scoped="scoped" lang="less">
  .d{
    margin-top: 20px;
      .marginl10{
        margin-bottom: 10px;
        .contactAddStyle{
          cursor: pointer;
          margin-left: 30px;
          float: right;
          font-size: 13px;
          color: #484646;
          font-weight: 400;
        }
        .contactAddStyle::before{
          content: '+';
          color: #00ABF9;
          width: 15px;
          height: 15px;
          display: inline-block;
          border-radius: 7.5px;
          text-align: center;
          line-height: 15px;
          font-size: 16px;
          margin-right: 5px;
          border: 1px solid #00ABF9;
        }
      }
  }
.formBox{
  .el-input{
    width: 300px;
  }
  .el-form-item__label{
    width: 100px;
    text-align: right;
    display: inline-block;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/cmd_center/star/ruserId.vue